import KpiConverter from "./kpi/converter/KpiConverter";
import KpiValidator from "./kpi/validator/KpiValidator";
import KpiMapper from "./kpi/mapper/KpiMapper";
import EQError from "../../../utils/EQError";

export default class GatewayModule {
    /**
     * Constructor
     *
     * @param brand
     * @param model
     * @param Converter
     * @param Validator
     * @param ip
     * @param username
     * @param password
     */
    constructor(brand, model, Converter = null, Validator = null, Mapper = null, ip = null, username = null, password = null) {
        this.brand = brand;
        this.model = model;
        this.ip = ip;
        this.converter = Converter ? new Converter(this.brand, this.ip) : new KpiConverter(this.brand, this.ip);
        this.validator = Validator ? new Validator() : new KpiValidator();
        this.mapper = Mapper ? new Mapper() : new KpiMapper();
        this.username = username;
        this.password = password;
    }

    /**
     * Returns the URL to ping (override if needed)
     *
     * @returns {string} The ping URL
     */
    getPingUrl() {
        return "http://" + this.ip;
    }

    /**
     * Validate the headers to confirm the ping (override if needed)
     *
     * @param headers The HTTP headers
     * @returns {boolean} True if headers are valid, false otherwise
     */
    validateHeaders() {
        return true;
    }

    /**
     * Authenticate action to the gateway (override if needed)
     *
     * @returns {Promise} A promise with the module as return, or en EQError
     */
    authenticate() {
        return new Promise((resolve) => {
           resolve(this);
        });
    }

    /**
     * Call all APIs available
     * Note that authentication should be ran before
     *
     * @returns {Promise} A promise with an Object with API results as return, or an EQError
     */
    getApiInfo() {
        throw new EQError("getApiInfo must be overriden", 624411);
    }

    /**
     * Process the rawData kpi
     *
     * @param rawData
     * @param converters
     * @returns {Promise}
     */
    processKpi(rawData, converters) {
        const self = this;
        return new Promise((resolve, reject) => {
            if (self.converter && self.validator) {
                self.converter.convert(rawData, converters)
                    .then((rawKpi) => {
                        self.validator.validate(rawKpi).then((rawKpi) => {
                            self.mapper.map(rawKpi).then((kpi) => {
                                resolve(kpi);
                            }).catch((e) => {
                                reject(new EQError(e.message, 624430));
                            });
                        }).catch((e) => {
                            reject(new EQError(e.message, 624420));
                        });
                    }).catch((e) => {
                        reject(new EQError(e.message, 624410));
                    });
            } else {
                reject(new EQError("No converter or validator set for this module", 624409));
            }
        });
    }
}


// WEBPACK FOOTER //
// ./js/core/gateway/service/modules/GatewayModule.js